import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Typography from "@mui/material/Typography";
import * as React from "react";
import DatePicker from "react-datepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import "react-datepicker/dist/react-datepicker.css";
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    style={{
      height: "37px",
      paddingLeft: "45px",
      border: "1.5px solid #ccc",
      borderRadius: "5px",
    }}
    className="example-custom-input"
    onClick={onClick}
    value={value}
    ref={ref}
  />
));

export default function DateFilter({
  selected,
  setSelected,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  const handleClick = (event, newSelection) => {
    setSelected(newSelection);
  };
  const [localStartDate, setLocalStartDate] = React.useState(startDate);
  const [localEndDate, setLocalEndDate] = React.useState(endDate);
  const onStartDateChangeSingle = (date) => {
    setLocalStartDate(date.setHours(0, 0, 0, 0));
    setLocalEndDate(date.setHours(23, 59, 59, 999));
  };
  const onStartDateChangeRange = (date) => {
    setLocalStartDate(date.setHours(0, 0, 0, 0));
  };
  const onEndDateChangeRange = (date) => {
    setLocalEndDate(date.setHours(23, 59, 59, 999));
  };

  React.useEffect(() => {
    if (selected === "Single") {
      setLocalStartDate(startDate);
      setLocalEndDate(new Date(startDate).setHours(23, 59, 59, 999));
    }
  }, [selected, startDate]);

  const applyDates = () => {
    setStartDate(localStartDate);
    setEndDate(localEndDate);
  };
  return (
    <Box display="flex">
      <Box mr={2}>
        <Typography variant="h6" gutterBottom component="div">
          Date Filter
        </Typography>
        <ButtonGroup variant="outlined" color="primary">
          {["Single", "Range"].map((option) => (
            <Button
              key={option}
              onClick={(event) => handleClick(event, option)}
              variant={selected === option ? "contained" : "outlined"}
            >
              {option}
            </Button>
          ))}
        </ButtonGroup>
      </Box>
      {selected === "Single" ? (
        <Box>
          <Typography variant="h6" gutterBottom component="div">
            Start Date
          </Typography>
          <DatePicker
            customInput={<CustomInput />}
            icon={<DateRangeIcon style={{ color: "#2B3D4F" }} />}
            showIcon
            selected={localStartDate}
            onChange={(date) => onStartDateChangeSingle(date)}
          />
        </Box>
      ) : (
        <Box display="flex">
          <Box mr={2}>
            <Typography variant="h6" gutterBottom component="div">
              Start Date
            </Typography>
            <DatePicker
              customInput={<CustomInput />}
              showIcon
              icon={<DateRangeIcon style={{ color: "#2B3D4F" }} />}
              selected={localStartDate}
              onChange={(date) => onStartDateChangeRange(date)}
            />
          </Box>
          <Box>
            <Typography variant="h6" gutterBottom component="div">
              End Date
            </Typography>
            <DatePicker
              customInput={<CustomInput />}
              showIcon
              icon={<DateRangeIcon style={{ color: "#2B3D4F" }} />}
              selected={localEndDate}
              onChange={(date) => onEndDateChangeRange(date)}
            />
          </Box>
        </Box>
      )}
      <Box ml={2} mt={5}>
        <Button variant="contained" color="primary" onClick={applyDates}>
          Apply
        </Button>
      </Box>
    </Box>
  );
}
